/* eslint-disable jsx-a11y/no-static-element-interactions */

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { scheduleItemVideoProcessor } from 'helpers/VideoProcessorHelper';
import { getVideoData } from 'screens/Live/LiveHelpers';
import Style from './UpNextToast.module.scss';

const UpNextToast = ({ video, onWatch, onHide, renderImage }) => {
  if (!video) return null;
  const { title } = getVideoData(video);
  const { image } = scheduleItemVideoProcessor({ item: video });
  const { overrun_scenario_text: overrunScenarioText } = window.Language;
  return (
    <div className={Style.container}>
      <div className={Style.detailContainer}>
        {renderImage({
          className: Style.image,
          src: image,
          alt: title,
        })}
        <div className={Style.infoContainer}>
          <div className={Style.titleContainer}>
            <div>{overrunScenarioText}</div>
            <div className={Style.title}>{title}</div>
          </div>
          <div className={Style.actionButtons}>
            <Link className={Style.primaryButton} onClick={onWatch}>
              Watch Live
            </Link>
            <Link className={Style.secondaryButton} onClick={onHide}>
              Hide
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpNextToast;

UpNextToast.propTypes = {
  renderImage: PropTypes.func.isRequired,
  video: PropTypes.shape({}).isRequired,
  onWatch: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
  theme: PropTypes.shape({}),
};

UpNextToast.defaultProps = {
  theme: {},
};
